module.exports = __webpack_public_path__ + "img/background-img.6396021b.png";